import React, {
    useState,
    useEffect,
    useCallback
} from "react";

import dayjs from "dayjs";

import { motion } from "framer-motion";

import AttendanceHeader from "./AttendanceHeader";
import AttendanceStatistics from "./AttendanceStatistics";
import AttendanceSearch from "./AttendanceSearch";
import AttendanceCalendar from "./AttendanceCalendar";
import AttendanceDayModal from "./AttendanceDayModal";

import attendanceService from "../services/attendanceService";

import "../styles/attendance.css";


export default function AttendancePage() {


    const [currentDate, setCurrentDate] = useState(new Date());

    const [selectedDate, setSelectedDate] = useState(new Date());

    const [calendar, setCalendar] = useState([]);

    const [statistics, setStatistics] = useState({});

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const [selectedAttendance, setSelectedAttendance] = useState([]);

    const [showModal, setShowModal] = useState(false);

    const [searchResults, setSearchResults] = useState([]);



    const month = dayjs(currentDate).month() + 1;

    const year = dayjs(currentDate).year();



    const loadCalendar = useCallback(async () => {

        try {

            setLoading(true);

            setError("");

            const [

                calendarResponse,

                statisticsResponse

            ] = await Promise.all([

                attendanceService.calendar(

                    month,

                    year

                ),

                attendanceService.summary(

                    month,

                    year

                )

            ]);

            setCalendar(

                calendarResponse.calendar || []

            );

            setStatistics(

                statisticsResponse.statistics || {}

            );

        }

        catch (err) {

            console.error(err);

            setError(

                "Unable to load attendance."

            );

        }

        finally {

            setLoading(false);

        }

    }, [

        month,

        year

    ]);



    useEffect(() => {

        loadCalendar();

    }, [

        loadCalendar

    ]);



    const previousMonth = () => {

        setCurrentDate(

            previous =>

                dayjs(previous)

                    .subtract(

                        1,

                        "month"

                    )

                    .toDate()

        );
        setSelectedDate(previous =>

            dayjs(previous)

                .subtract(

                    1,

                    "month"

                )

                .toDate()

        );

    };



    const nextMonth = () => {

        setCurrentDate(

            previous =>

                dayjs(previous)

                    .add(

                        1,

                        "month"

                    )

                    .toDate()

        );

        setSelectedDate(previous =>

            dayjs(previous)

                .add(

                    1,

                    "month"

                )

                .toDate()

        );

    };

    const goToToday = () => {

        const today = new Date();

        setCurrentDate(today);

        setSelectedDate(today);

    };


    const refreshCalendar = () => {

        loadCalendar();

    };


    const handleDateClick = useCallback(

        (date) => {

            setSelectedDate(date);

            const attendance = calendar.filter(

                item =>

                    dayjs(

                        item.attendance_date

                    ).isSame(

                        date,

                        "day"

                    )

            );

            setSelectedAttendance(

                attendance

            );

            setShowModal(true);

        },

        [

            calendar

        ]

    );


    const handleSearchSelection = useCallback(

        (session) => {

            const date = new Date(

                session.attendance_date

            );

            setCurrentDate(date);

            setSelectedDate(date);

            setSearchResults([

                session

            ]);

            handleDateClick(date);

        },

        [

            handleDateClick

        ]

    );


    const closeModal = () => {

        setShowModal(false);

    };



    return (

        <section >

        <motion.div

            className="attendance-page"

            initial={{

                opacity: 0

            }}

            animate={{

                opacity: 1

            }}

            transition={{

                duration: .35

            }}

        >

            
            <AttendanceSearch

                onSelect={handleSearchSelection}

            />
            <AttendanceHeader

                currentDate={currentDate}

                onPreviousMonth={previousMonth}

                onNextMonth={nextMonth}

                onToday={goToToday}

                onRefresh={refreshCalendar}

                loading={loading}

            />

        




            {

                loading &&

                <div className="attendance-loading">

                    <div className="attendance-loader" />

                    <h3>

                        Loading attendance...

                    </h3>

                </div>

            }

            {

                !loading &&

                error &&

                <div className="attendance-error">

                    {error}

                </div>

            }

            {

                    !loading &&

                    !error &&

                    calendar.length === 0 &&

                <div className="attendance-empty-page">

                    <div className="attendance-empty-icon">

                        📅

                    </div>

                    <h2>

                        No  Attendance Found

                    </h2>

                    <p>

                        There are no attendance records available for

                        {

                            dayjs(currentDate)

                                .format(

                                    "MMMM YYYY"

                                )

                        }

                    </p>

                </div>

            }

            {

                !loading &&

                !error &&

                calendar.length > 0 &&

                <div className="attendance-calendar-section">

                    <AttendanceCalendar

                        selectedDate={selectedDate}

                        onDateChange={handleDateClick}

                        calendar={calendar}

                        loading={loading}

                        searchResults={searchResults}

                    />

                </div>

            }

            <div className="attendance-page-footer">

                <span>

                    Showing

                    {" "}

                    <strong>

                        {calendar.length}

                    </strong>

                    {" "}

                    attendance record(s)

                </span>

                <span>

                    Updated

                    {" "}

                    {

                        dayjs()

                            .format(

                                "DD MMM YYYY HH:mm"

                            )

                    }

                </span>

            </div>

       

                <AttendanceStatistics

                statistics={statistics}

            />
        </motion.div>

        <div  style={{ position :"relative"}}>

             <AttendanceDayModal

                open={showModal}

                attendance={selectedAttendance}

                selectedDate={selectedDate}

                onClose={closeModal}

            />

            </div>

        </section>

    );


}